import React, { useState } from "react";
import { Link } from "react-router-dom";
import emailjs from "@emailjs/browser";
import {
  Mail,
  Phone,
  MapPin,
  ArrowRight,
  Send,
  Linkedin,
  Instagram,
} from "lucide-react";
import "../Styling/Footer.css";

export default function Footer() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
    company: "", // honeypot
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Honeypot check (bots)
    if (form.company) return;

    setStatus("Sending...");

    emailjs
      .send(
        "service_8knu1bd",
        "template_r4a706c",
        {
          from_name: form.name,
          from_email: form.email,
          message: form.message,
        },
        "YT2VTVo7DBR7Ub75i"
      )
      .then(
        () => {
          setStatus("Message sent successfully.");
          setForm({
            name: "",
            email: "",
            message: "",
            company: "",
          });
        },
        () => {
          setStatus("Failed to send message. Try again later.");
        }
      );
  };

  return (
    <footer className="CN-footer">
      <div className="CN-footer-grid-overlay"></div>
      <div className="container">
        <div className="row">
          {/* Brand & Contact */}
          <div className="col-lg-5 col-md-12 mb-4">
            <h3 className="CN-footer-brand">Digital Dream Works</h3>
            <p className="CN-footer-description">
              An AI and Software Studio building production-ready systems for agencies, enterprises, and strategic partners. Designed for real operations. Deployed for scale.
            </p>

            <div className="CN-footer-contact">
              <div className="CN-footer-contact-item">
                <MapPin size={18} className="CN-footer-icon" />
                <span>
                  Digital Dream Works LLC <br /> St. Petersburg, FL, USA
                </span>
              </div>
              <div className="CN-footer-contact-item">
                <Mail size={18} className="CN-footer-icon" />
                <a href="mailto:hello@DigitalDreamWorksAgency.com">
                  hello@DigitalDreamWorksAgency.com
                </a>
              </div>
              <div className="CN-footer-contact-item">
                <Phone size={18} className="CN-footer-icon" />
                <a href="tel:+17867352988">+1 786 735 2988</a>
              </div>
            </div>

            <div className="CN-footer-socials">
              <a
                href="https://www.linkedin.com/company/digital-dream-works"
                target="_blank"
                rel="noopener noreferrer"
                className="CN-footer-social-link"
              >
                <Linkedin size={20} />
              </a>


              <a
                href="https://www.instagram.com/digi.dreamworks?igsh=MWVyZjI1dDhnYTYyNw=="
                target="_blank"
                rel="noopener noreferrer"
                className="CN-footer-social-link"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Links */}
          <div className="col-lg-2 col-md-6 mb-4">
            <h4 className="CN-footer-title">Explore</h4>
            <ul className="CN-footer-links-list">
              <li>
                <Link to="/AboutUs" className="CN-footer-link">
                  <ArrowRight size={16} className="CN-link-arrow" /> About
                </Link>
              </li>
              <li>
                <Link to="/Labs" className="CN-footer-link">
                  <ArrowRight size={16} className="CN-link-arrow" /> Labs
                </Link>
              </li>
              <li>
                <Link to="/PartnerShips" className="CN-footer-link">
                  <ArrowRight size={16} className="CN-link-arrow" />{" "}
                  Partnerships
                </Link>
              </li>
              <li>
                <Link to="/How_we_work" className="CN-footer-link">
                  <ArrowRight size={16} className="CN-link-arrow" /> How We Work
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Form */}
          <div className="col-lg-5 col-md-12">
            <h4 className="CN-footer-title">Enterprise Contact</h4>

            <form className="CN-footer-form" onSubmit={handleSubmit}>
              {/* Honeypot */}
              <input
                type="text"
                name="company"
                value={form.company}
                onChange={handleChange}
                style={{ display: "none" }}
              />

              <div className="CN-input-group">
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="CN-input-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Work Email"
                  value={form.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="CN-input-group">
                <textarea
                  name="message"
                  placeholder="How can we help?"
                  rows="3"
                  value={form.message}
                  onChange={handleChange}
                  required
                />
              </div>

              <button type="submit" className="CN-submit-btn">
                <span>Send Inquiry</span>
                <Send size={16} />
              </button>

              {status && <p className="CN-footer-form-status">{status}</p>}
            </form>
          </div>
        </div>

        <div className="CN-footer-bottom">
          <p style={{ marginBottom: "0.5rem", opacity: "0.7", fontSize: "0.9rem" }}>
            Digital Dream Works builds operational AI systems for regulated industries, including healthcare.
          </p>
          <p>© 2026 Digital Dream Works. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
